import './styles/style.scss'; 

import App from './js/App';


const root = ReactDOM.createRoot(document.querySelector("#pf__products"))
if (root){
    root.render(<App />)
}
